import { Button } from '@shared/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  error: unknown;
  onRetry: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
  const { t } = useTranslation('minimumFeesModule');
  const message = error instanceof Error ? error.message : String(error || t('errors.unexpected', 'Error inesperado'));

  return (
    <div className="flex min-h-[calc(100vh-180px)] items-center justify-center px-6">
      <div className="flex max-w-md flex-col items-center gap-3 text-center">
        <AlertTriangle className="h-10 w-10 text-destructive" />
        <h3 className="text-lg font-semibold text-title">{t('errors.loadTitle', 'Error al cargar cuotas mínimas')}</h3>
        <p className="text-sm text-muted-foreground">{message}</p>
        <Button variant="outline" size="sm" onClick={onRetry}>
          {t('errors.retry', 'Reintentar')}
        </Button>
      </div>
    </div>
  );
};
